export default {"src":"/_next/static/media/lightprogress.c58eaaa0.gif","height":240,"width":240,"blurWidth":0,"blurHeight":0};